/* ================= Ajax cart ===================== */

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};
// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),
    $changeView              : $('.change-view')
  };
};
timber.init = function () {
  // FastClick is not loaded by this theme, so this init has always stopped at its first line
  // ("FastClick is not defined" on every page) and the old Timber drawers below never ran.
  // Exit quietly instead: same behaviour, no console error, dormant drawers stay off.
  if (typeof FastClick === 'undefined') return;
  FastClick.attach(document.body);
  timber.cacheSelectors();

  timber.drawersInit();
};
timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  
};
/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers=function(){var a=function(a,b,c){var d={close:".js-drawer-close",open:".js-drawer-open-"+b,openClass:$("tr.cart__row").data("line")?"":"js-drawer-open",dirOpenClass:"js-drawer-open-"+b};return this.$nodes={parent:$("body, html"),page:$("#PageContainer"),moved:$(".is-moved-by-drawer")},this.config=$.extend(d,c),this.position=b,this.$drawer=$("#"+a),!!this.$drawer.length&&(this.drawerIsOpen=!1,void this.init())};return a.prototype.init=function(){$(this.config.open).on("click",$.proxy(this.open,this)),this.$drawer.find(this.config.close).on("click",$.proxy(this.close,this))},a.prototype.open=function(a){var b=!1;return a?a.preventDefault():b=!0,a&&a.stopPropagation&&(a.stopPropagation(),this.$activeSource=$(a.currentTarget)),this.drawerIsOpen&&!b?this.close():(timber.cache.$body.trigger("beforeDrawerOpen.timber",this),this.$nodes.moved.addClass("is-transitioning"),this.$drawer.prepareTransition(),this.$nodes.parent.addClass(this.config.openClass+" "+this.config.dirOpenClass),this.drawerIsOpen=!0,this.trapFocus(this.$drawer,"drawer_focus"),this.config.onDrawerOpen&&"function"==typeof this.config.onDrawerOpen&&(b||this.config.onDrawerOpen()),this.$activeSource&&this.$activeSource.attr("aria-expanded")&&this.$activeSource.attr("aria-expanded","true"),this.$nodes.page.on("touchmove.drawer",function(){return!1}),this.$nodes.page.on("click.drawer",$.proxy(function(){return this.close(),!1},this)),void timber.cache.$body.trigger("afterDrawerOpen.timber",this))},a.prototype.close=function(){this.drawerIsOpen&&(timber.cache.$body.trigger("beforeDrawerClose.timber",this),$(document.activeElement).trigger("blur"),this.$nodes.moved.prepareTransition({disableExisting:!0}),this.$drawer.prepareTransition({disableExisting:!0}),this.$nodes.parent.removeClass(this.config.dirOpenClass+" "+this.config.openClass),this.drawerIsOpen=!1,this.removeTrapFocus(this.$drawer,"drawer_focus"),this.$nodes.page.off(".drawer"),timber.cache.$body.trigger("afterDrawerClose.timber",this))},a.prototype.trapFocus=function(a,b){var c=b?"focusin."+b:"focusin";a.attr("tabindex","-1"),a.focus(),$(document).on(c,function(b){a[0]===b.target||a.has(b.target).length||a.focus()})},a.prototype.removeTrapFocus=function(a,b){var c=b?"focusin."+b:"focusin";a.removeAttr("tabindex"),$(document).off(c)},a}();
// Initialize Timber's JS on docready
$(timber.init);




function fetchMiniCart(){
	$.getJSON("/cart.js", {
        format: "json"
    })
    .done(function( data ) {
      $("#minicard").html("");
      if(data.items.length){
        var source = $("#MiniCartTemplate").html(),
            template = Handlebars.compile(source);            
        for($i=0;$i<data.items.length;$i++){
          var extendFile = "_small." + /[^\.]*$/.exec(data.items[$i].image)[0];
          data.items[$i].image = data.items[$i].image.replace(/\.[^/.]+$/,extendFile);
          data.items[$i].line = $i + 1;
          data.items[$i].price = Shopify.formatMoney(data.items[$i].price, theme.moneyFormat)
        }

        $("#minicard").append(template(data));
        //$(".mini-cart-total").html((Shopify.formatMoney($(".mini-cart-total .money").html(), theme.moneyFormat)));
        
        updateFreeShip(data);          
        
          
      }
      else{
          $("#minicard").append('<p>' + 'Your cart is currently empty.' + '</p>');  
      }
      $('#CartCount').text(data.item_count);
    });            
}
$(function(){
  $( "div.cart_mini" )
    .hover(function(){
       $(function() {
        fetchMiniCart();
        $('.cart_mini').addClass('open-cart');
      });
    },function(){
      $('.cart_mini').removeClass('open-cart');
    });

    $( "body .apQtyAdjust " ).click(function() {
      console.log( "Handler for .click() called." );
    }); 
    
});


/* ================= User login =================== */  
function userLogin(){
	$(".customer_login_wrapper input[type='submit']").click(function(e){
      e.preventDefault();
      var d = $(this).parent().parent();
      $.ajax({
        type:"POST",
        url:"/account/login",
        data:d.serialize(),
        beforeSend:function(){},
        success:function(n){
          d.html('Login suceess!');
          if (!!$.prototype.fancybox)
            $.fancybox.open([{
              type: 'inline',
              autoScale: true,
              minHeight: 30,
              content: '<p class="fancybox-error">' + 'You are logged' + '</p>'
            }], {
              padding: 50
            });
          else{
            	alert('You are logged');
              }
        },
        error:function(){
          console.log("Login failed");          
        }
      })
    });
}
/* ================= Wishlist ===================== */
function initWishlist(){
  	if (theme.wishlist_enable) {
        $(".wishlist button.btn-wishlist").click(function(e){
            e.preventDefault();
            var d = $(this).parent();
            $.ajax({
                type:"POST",
                url:"/contact",
                data:d.serialize(),
                beforeSend:function(){
                },
                success:function(n){
                  d.html('<a class="btn btn-outline-inverse btn-wishlist added" href="'+ theme.wishlist_url +'"><i class="fa fa-heart"></i><span>Go to Wishlist</span></a>');
                  if (!!$.prototype.fancybox)
                        $.fancybox.open([{
                            type: 'inline',
                            autoScale: true,
                            minHeight: 30,
                            content: '<p class="fancybox-error">' + 'Added to your wishlist.' + '</p>'
                        }], {
                            padding: 0
                        });
                  else{
                    getAllWishlist();
                    alert('Added to your wishlist.');
                  }
                },
                error:function(){
                }
            })
        });
    }
}
function addSwatchToItem() {
    $('.product-block').each(function() {
        $(this).find('.proVariants select').hide();
        $(this).find('.proVariants input[type="radio"]').hide();
    });
    $('.product-block .swatch-element label').bind("click touchstart", function(){
        var variantId = $(this).data("id");
        var dropSelect = $(this).closest('.proVariants').find('select');
        $(dropSelect).val(variantId).trigger('change');
    });
}
/* ================= Compare ===================== */                   
function getCookieVal (offset) {
		var endstr = document.cookie.indexOf (";", offset);
		if (endstr == -1)
			endstr = document.cookie.length;
		return unescape(document.cookie.substring(offset, endstr));
	}
	function FixCookieDate (date) {
		var base = new Date(0);
		var skew = base.getTime();
		if (skew > 0)
			date.setTime (date.getTime() - skew);
	}
	function GetCookie (name) {
		var arg = name + "=";
		var alen = arg.length;
		var clen = document.cookie.length;
		var i = 0;
		while (i < clen) {
			var j = i + alen;
			if (document.cookie.substring(i, j) == arg)
				return getCookieVal (j);
			i = document.cookie.indexOf(" ", i) + 1;
			if (i == 0) break;
		}
		return null;
	}
	function SetCookie (name,value,expires,path,domain,secure) {
		document.cookie = name + "=" + escape (value) +
			((expires) ? "; expires=" + expires.toGMTString() : "") +
			((path) ? "; path=" + path : "") +
			((domain) ? "; domain=" + domain : "") +
			((secure) ? "; secure" : "");
	}
	function DeleteCookie (name,path,domain) {
		if (GetCookie(name)) {
			document.cookie = name + "=" +
				((path) ? "; path=" + path : "") +
				((domain) ? "; domain=" + domain : "") +
				"; expires=Thu, 01-Jan-70 00:00:01 GMT";
		}
	}
	function CheckShowHidden() {
		if(jQuery('.ap_cp_item').length > 0){
			jQuery('#ap_compare_paneltool').show();
		} else {
			juery('#ap_compare_paneltool').hidden();
		}
	}
	function CountCookie() {
			var item = jQuery(".ap_cp_item").length - 1 ;
			var apCompare = '<a class="log-only" title="compare" href="'+apCompareUrl+'/pages/ap-compare-product">So Sánh('+ item +')</a>';
			jQuery("#ap_compare_item").html(apCompare);
	}
	function getCountCompare(listCompare) {
		// Hien thi link product  list compare
		var apCountCompare = 0;
		if (listCompare.length > 0) {
			apCountCompare = listCompare.match(/,/g || []);
			if(apCountCompare) {
				apCountCompare = apCountCompare.length;
			} else {
				apCountCompare = 1;
			}
			if (apCountCompare == undefined) apCountCompare = 0;
		}
		jQuery("#cart-count").html('<a href="'+apCompareUrl+'/pages/ap-compare-product">So sánh('+apCountCompare+')</a>');
	}
	var apCompareUrl = document.location.origin;
	var ap_d = new Date();
	ap_d = ap_d.getTime() + 31536000000;
	ap_expires = new Date(ap_d);
	jQuery(document).ready(function() {
		//hien thi gt cu khi load trang
		var aplistCookie = GetCookie("apCpProduct");
		if(aplistCookie != null) {
		 getCountCompare(aplistCookie);
			var aplistCookie = aplistCookie.split(',');
			for(key in aplistCookie) {
        var apCpId = aplistCookie[key];
				if(apCpId.length) {
					//khong hien thi tren page comparation
					var apComparePath = window.location.pathname;
					if (apComparePath.search("/pages/ap-compare-product") < 0) {
						jQuery("#ap_compare_paneltool").show();
					}
					jQuery.ajax({
						url: apCompareUrl + "/products/" + apCpId + '.json',
						type: "GET",
						dataType: "json",
						success: function(result){
							var apCpHandle = result["product"]["handle"];
							if (result["product"]["image"] == null) {
								var apCpImg = "//hstatic.net/0/0/global/noDefaultImage6_large.gif";
							} else {
								var apCpImg = result["product"]["image"]["src"];
							}
							var apCpTitle = result["product"]["title"];
							var apCpElement = '<div class="ap_cp_item" data-id="'+apCpHandle+'"><div class="ap_cp_remove"><p class="ap-cp-image-trash"></p></div><div class="ap_cp_detail"><div class="ap_cp_img"><img src="'+apCpImg+'"></div> <div class="ap_cp_content">'+apCpTitle+'</div></div></div>';
							jQuery(".ap-cp-list-item").append(apCpElement);
							jQuery("input.ap-cp-add[data-id='" +apCpHandle+ "']").prop("checked", true);
						},
						complete: function() {
												CountCookie();	
											},
						error: function() {
							console.log("There have error data. Please refresh page and try again!");
						}
					});
				}
			}
		}
		jQuery(".ap_cp_btn").click(function() {
			if(jQuery("#ap_compare_paneltool").hasClass("ap-cp-active")) {
				jQuery("#ap_compare_paneltool").removeClass("ap-cp-active");
			} else {
				jQuery("#ap_compare_paneltool").addClass("ap-cp-active");
			}
		});
		jQuery(".ap-cp-add").click(function() {
			var apCpImg = $(this).attr("data-img");
			var apCpTitle = $(this).attr("data-title");
			var apCpId = $(this).attr("data-id");
			if(jQuery(this).is(':checked')) {
				var max = 4;
				if(jQuery(".ap_cp_item").length > max) {
					alert("You can only compare up "+ max + " product") ;
					jQuery(this).prop("checked", false);
				} else {
					//create Element
					var apCpElement = '<div class="ap_cp_item" data-id="'+apCpId+'"><div class="ap_cp_remove"><p class="ap-cp-image-trash"><i class="fa fa-trash-o" aria-hidden="true"></i></p></div><div class="ap_cp_detail"><div class="ap_cp_img"><img src="'+apCpImg+'"></div> <div class="ap_cp_content">'+apCpTitle+'</div></div></div>';
					jQuery(".ap-cp-list-item").append(apCpElement);
					//set cookie
					var aplistCookie = GetCookie("apCpProduct");
					if(aplistCookie == null) {
						var aplistCookie = [];
						aplistCookie.push(apCpId);
						SetCookie("apCpProduct", aplistCookie, ap_expires, "/");
					} else {
						var aplistCookie = aplistCookie.split(',');
						aplistCookie.push(apCpId);
						SetCookie("apCpProduct", aplistCookie, ap_expires, "/");
					}
				}
			} else {
				//delte cookie item product
				var aplistCookie = GetCookie("apCpProduct");
				var aplistCookie = aplistCookie.split(',');
				var index = aplistCookie.indexOf(apCpId);
				if (index > -1) {
					aplistCookie.splice(index, 1);
				}
				SetCookie("apCpProduct", aplistCookie, ap_expires, "/");
				//remove element
				jQuery(".ap-cp-list-item .ap_cp_item[data-id='" +apCpId+"']").remove();
			}
			CountCookie();
			CheckShowHidden();
			//hien thi element link list compare
			var aplistCookieElement = GetCookie("apCpProduct");
			getCountCompare(aplistCookieElement);
			$(".ap_cp_btn").addClass("ap_cp_shake");
			setTimeout(function() {
				$(".ap_cp_btn").removeClass("ap_cp_shake") }, 1000
			);
		});
	});
	//remove item product panel tool
	jQuery(document).on("click", ".ap_cp_remove", function(e) {
		e.stopPropagation();
		e.preventDefault();
		//delte cookie item product
		var apCpId = jQuery(this).parents(".ap_cp_item").first().attr("data-id");
		var aplistCookie = GetCookie("apCpProduct");
		var aplistCookie = aplistCookie.split(',');
		//check va bo gia tri product trong mang cookie
		var index = aplistCookie.indexOf(apCpId);
		if (index > -1) {
			aplistCookie.splice(index, 1);
		}
		SetCookie("apCpProduct", aplistCookie, ap_expires, "/");
		//remove element
		jQuery(this).parents(".ap_cp_item").first().remove();
		CountCookie();;
		CheckShowHidden();
		//hien thi element link list compare
		var aplistCookieElement = GetCookie("apCpProduct");
		getCountCompare(aplistCookieElement);
		//change checked
		jQuery("input.ap-cp-add[data-id='" +apCpId+ "']").prop("checked", false);
	});
	//redirect to page compare
	jQuery(".ap-cp-submit button.ap-cp-to-page").click(function() {
		window.location.href = apCompareUrl + "/pages/ap-compare-product";
	});

//filter with tag          

function showLoading() {$('#loading').show();}
function hideLoading() {$('#loading').hide();}
var currentLink = "";
$(function(){
  	$(".template-collection")&&History.Adapter.bind(window,"statechange",function(){History.getState(),isFilterAjaxClick||(filterParams(),reloadFilter()),isFilterAjaxClick=!1});
    function get_pagecount(){var a=1;return $("div#pagination ul.pagination li a").each(function(){parseInt($(this).html())>a&&(a=parseInt($(this).html()))}),a}
    function assign_tag(arr_all_list_tag){
      var arr_all_tag = new Array();
      var tag_current = process_tag_current();
      if(tag_current.length){
        var lang = $("div.ap-multilang-box > div > a").data("lang");
        if(lang) lang = lang.replace("ap_multilang_","");
        if(lang) lang = lang + '_';
		
        var str_current = '<ul>';
        
        
        var constraint = (Shopify.queryParams.constraint);
        tag_current = constraint.split("+");
        console.log("tag_current" +  tag_current);
        for(i=0;i<tag_current.length;i++){
          var param='';
          for(j=0;j<tag_current.length;j++){
            if(tag_current[i] != tag_current[j]){
              if(param == '') param=tag_current[j]; else param+='+' + tag_current[j];
            }
          }
          if(param){
            var link =$("div.root-filter").data("url") + '?constraint=' + param;
          }else{
            var link =$("div.root-filter").data("url");
          }
            link = link.replace("=+","=").replace(" ","_");
          
          
          
          var arr1 = ["Exclusive"];
          var tag_current_name = tag_current[i].replace(lang,'').replace(arr1[1],'');
          
          arr1 = [];
          tag_current_name = tag_current_name.replace(lang,'').replace(arr1[1],'');
          
          arr1 = [];
          tag_current_name = tag_current_name.replace(lang,'').replace(arr1[1],'');
          
          arr1 = [];
          tag_current_name = tag_current_name.replace(lang,'').replace(arr1[1],'');
          
          arr1 = [];          
          tag_current_name = tag_current_name.replace(lang,'').replace(arr1[1],'');          
          str_current +="<li>" + decodeURIComponent(tag_current_name.replace("_",' ').replace("_",' ')) + '<a href="'+link+'">x</a>' + "</li>";
        }
        str_current +='</ul>'
        console.log(str_current);
        $("div.list-current-tag").html(str_current);
      }
      var arr_tag = process_tag(arr_all_list_tag);
            
      	  
          var arr1 = ["Exclusive"];
          if(arr1.length){
              create_filter("product_" + arr1[1] + "_filter",arr1[1],arr_tag,arr1[2],arr1[0]);
          }
      
        
          
          var arr1 = [];
          if(arr1.length){
              create_filter("product_" + arr1[1] + "_filter",arr1[1],arr_tag,arr1[2],arr1[0]);
          }
      
      
          
          var arr1 = [];
          if(arr1.length){
              create_filter("product_" + arr1[1] + "_filter",arr1[1],arr_tag,arr1[2],arr1[0]);
          }
      
        
          
          var arr1 = [];
          if(arr1.length){
              create_filter("product_" + arr1[1] + "_filter",arr1[1],arr_tag,arr1[2],arr1[0]);
          }
      
        
          
          var arr1 = [];
          if(arr1.length){
              create_filter("product_" + arr1[1] + "_filter",arr1[1],arr_tag,arr1[2],arr1[0]);
          }
      
      responsiveFilter();
      $(window).resize(responsiveFilter);
      
        //create_filter("product_type_filter","type_",arr_tag,false,'Product type');
        //create_filter("product_color_filter","ap_colour_",arr_tag,true,"Colour");
    }
    
    function process_all_list_tag(a, b, c) {
    return jQuery.getJSON(b + "/products.json?limit=250&page=" + c, function(d) {
        if (d.products.length) {
            for (i = 0; i < d.products.length; i++) a.push(d.products[i].tags);
            process_all_list_tag(a, b, c + 1)
        } else assign_tag(a)
    }), a
}
  function process_tag(a) {
    var b = $("div.ap-multilang-box > div > a").data("lang");
    b && (b = b.replace("ap_multilang_", "")), b && (b += "_");
    var c = new Array,
        e = (new Array, new Array),
        f = process_tag_current();
    if (b)
        for (i = 0; i < a.length; i++)
            for (j = 0; j < a[i].length; j++) 0 == a[i][j].trim().indexOf(b) && e.push(a[i][j].trim());
    if (!b)
        for (i = 0; i < a.length; i++)
            for (j = 0; j < a[i].length; j++) e.push(a[i][j].trim());
    for (i = 0; i < e.length; i++) {
        var g = 0,
            h = {};
        for (j = 0; j < c.length; j++) e[i] == c[j].tag && g++;
        if (!g) {
            h.tag = e[i].trim();
            var l = 0;
            for (k = 0; k < e.length; k++) h.tag == e[k] && l++;
            h.count = l, c.push(h)
        }
    }
    if (f.length) {
        var m = new Array;
        for (i = 0; i < a.length; i++) {
            var o = 0;
            for (j = 0; j < a[i].length; j++)
                for (k = 0; k < f.length; k++) a[i][j] == f[k] && o++;
            if (o == f.length)
                for (j = 0; j < a[i].length; j++) m.push(a[i][j].trim())
        }
        if (m.length > 1)
            for (i = 0; i < c.length; i++) {
                for (l = 0, j = 0; j < m.length; j++) m[j] == c[i].tag && l++;
                c[i].count = l
            }
        for (i = 0; i < e.length; i++) {
            var g = 0,
                h = {};
            for (j = 0; j < c.length; j++) e[i] == c[j].tag && g++;
            if (!g) {
                h.tag = e[i].trim();
                var l = 0;
                for (k = 0; k < e.length; k++) h.tag == e[k] && l++;
                h.count = l, c.push(h)
            }
        }
    }
    return c.sort(function(a, b) {
        return a.tag > b.tag ? 1 : b.tag > a.tag ? -1 : 0
    }), c
}

function filterParams() {
    if (Shopify.queryParams = {}, location.search.length)
        for (var a, b = 0, c = location.search.substr(1).split("&"); b < c.length; b++) a = c[b].split("="), a.length > 1 && (Shopify.queryParams[decodeURIComponent(a[0])] = decodeURIComponent(a[1]))
}

function filterCreateUrl(a) {
    var b = $("div.root-filter").data("url"),
        c = $.param(Shopify.queryParams).replace(/%2B/g, "+");
    return b ? "" != c ? b + "?" + c : b : location.pathname + "?" + c
}

function filterAjaxClick(a, b) {
    var c = a;
    return b > 0 && (c = filterCreateUrl(a)), console.log("Link: " + c), isFilterAjaxClick = !0, History.pushState({
        param: Shopify.queryParams
    }, c, c), c
}

function reloadFilter() {
    if (Shopify.queryParams.view) {
        $(".change-view.change-view--active").removeClass("change-view--active");
        var a = Shopify.queryParams.view;
        a.indexOf("list") >= 0 ? $("[data-view='list']").addClass("change-view--active") : $("[data-view='grid']").addClass("change-view--active")
    }
}

function filterMapView() {
    $(".change-view").click(function(a) {
        a.preventDefault(), $(this).hasClass("change-view--active") || ("list" == $(this).data("view") ? Shopify.queryParams.view = "list" : Shopify.queryParams.view = "grid", $(".change-view").removeClass("change-view--active"), $(this).addClass("change-view--active"))
    })
}

function filterMapPaging() {
    $(".content_sortPagiBar .pagination a").click(function(b) {
        b.preventDefault();
        var c = a(this).attr("href").match(/page=\d+/g);
        if (c && (Shopify.queryParams.page = parseInt(c[0].match(/\d+/g)), Shopify.queryParams.page)) {
         
            var d = currentLink;
            isFilterAjaxClick = !0, History.pushState({
                param: Shopify.queryParams
            }, d, d), console.log("currentLink: " + d),
               (function() {
                Wishlist.init();
              }()),
              countproducttop(d), $("body,html").animate({
                scrollTop: 500
            }, 600)
        }
    })
}
function process_tag_current() {
    var a = new Array,
        b = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(a, c, d) {
        b[c] = d
    });
    b.constraint && (a = b.constraint.split("+"));
    var d = window.location.pathname.replace($("div.root-filter").data("url"), "").replace("/", "");
    return d && a.push(d), a
}
  function create_filter(id,tag_type, value,img,name) {
      var lang = $("div.ap-multilang-box > div > a").data("lang");
      if(lang) lang = lang.replace("ap_multilang_","");
      if(lang) lang = lang + '_';
      var imgurl="//scentclub.ca/cdn/shop/t/166/assets/blue.jpg?v=64864554530733511141786809536";
      var arr_current_tag = process_tag_current();
      var current_tag = '';
      var baseurl=$("div.root-filter").data("url");
      for(i=0;i<arr_current_tag.length;i++) {
        if(arr_current_tag[i].indexOf(tag_type)>=0) {
        	current_tag = decodeURIComponent(arr_current_tag[i]);          	
        }
      }
      var link =baseurl;
      if(typeof(Shopify.queryParams.constraint) != 'undefined'){
        var constraint = Shopify.queryParams.constraint;
        var array = constraint.split("+");
        var index = array.indexOf(current_tag);
        if (index > -1) {
            array.splice(index, 1);
        }
        if(array.length){
           link += '?constraint=' + array.join("+");
        }
      }
      console.log(Shopify.queryParams.constraint);
      
      var str='<div class="catalog_filters block sidebarCategories">';
      str += '<h4 class="title_block">'+ name + '</h4>';
      if(current_tag != ''){
        str += '<a href="'+ link +'" class="clear-filter">' + 'Clear ' + '</a>';
      }
      str += '<div class="block_content block_content_filter"><ul class="listSidebar list-unstyled">'
	 // console.log(arr_current_tag);
     // console.log(Shopify.queryParams.constraint);
      for(i=0;i<value.length;i++){
        if(value[i]["tag"].indexOf(tag_type)>=0){
          
          var param='';
          if(typeof(Shopify.queryParams.constraint) != 'undefined'){
            var constraint = Shopify.queryParams.constraint;
            var array = constraint.split("+");
            var index = array.indexOf(current_tag);
            if (index > -1) {
                array.splice(index, 1);
            }
            if(array.length){
               param = array.join("+");
            }

          }
          
          if(arr_current_tag.indexOf(value[i]["tag"]) >= 0){
            if(param){
              var link =baseurl + '?constraint=' + param;
            }else{
              var link =baseurl;
            }
          	
          }else{
            var link =baseurl + '?constraint=' + param + "+" + value[i]["tag"];
          }
          console.log(param);
          link = link.replace("=+","=");
          str += '<li class="advanced-filter">';
          if(value[i]["count"] > 0 ){            
            if(theme.multiple_filter_sidebar_enable){              
              if(arr_current_tag.indexOf(value[i]["tag"]) >= 0){
                str += '<a href="' + link + '" class="catalog_size filter-active">';
              }else{
                str += '<a href="' + link + '" class="catalog_size">';
              }
            }else{
              if(current_tag == value[i]["tag"]){
                str += '<a href="' + link + '" class="catalog_size filter-active">';
              }else{
                str += '<a href="' + link + '" class="catalog_size">';
              }
            }            
            if(img){
              var colorimg = value[i]["tag"].replace(lang,'').replace(tag_type,"").toLowerCase() + '.jpg';
              str += '<img src="'+ imgurl.replace("blue.jpg",colorimg) +'">';
            }
            str += ' ' + value[i]["tag"].replace(lang,'').replace(tag_type,"").replace("_"," ").replace("_"," ").replace("_"," ");
            str += '<span class="apolloQty">' + value[i]["count"] + '</span>';
            str += '</a>';
          }else{
            str += '<a class="catalog_size catalog_size_hidden" href="#">';
            if(img){
              var colorimg = value[i]["tag"].replace(lang,'').replace(tag_type,"").toLowerCase() + '.jpg';
              str += '<img src="'+ imgurl.replace("blue.jpg",colorimg) +'"> ';
            }
            str += ' ' + value[i]["tag"].replace(lang,'').replace(tag_type,"").replace("_"," ").replace("_"," ").replace("_"," ");
            str += '<span class="apolloQty">' + value[i]["count"] + '</span>';
            str += '</a>';
          }
          str += '</li>';
        }
      }
      str += '</ul></div></div>';
      $("img.loadding-filter").remove();
      $("#"+id).html(str);      

    }  	
	filterParams();
    $(document).on("click", ".filter-group a", function(a){
	currentLink = $(this).attr("href");
    var b = process_tag_current();
    b.length ? Shopify.queryParams.constraint = currentLink.replace($("div.root-filter").data("url"), "").replace("?constraint=", "") : delete Shopify.queryParams.constraint;
    var c = filterAjaxClick(currentLink, b.length);
    
    if(typeof(c)=="undefined") c = currentLink;
      
    console.log("c=" + c);
      if($("#product_list").hasClass('list')){
        c+='&view=list';
      }else{
        c+='&view=grid';
      }
    console.log("c=" + c);  
    return $.ajax({
        type: "GET",
        url: c,
        async:false,
        beforeSend: function() {
            showLoading()
        },
        complete: function(b) {
          	var constraint = Shopify.queryParams.constraint;
          	if(constraint.length == 0) $(".list-current-tag ul").remove();

            $("#product_list").html($("#product_list", b.responseText).html()), $(".pagi-block").empty(), $(".pagi-block").html($(".pagi-block", b.responseText).html()), $(a).closest("product_filter_item").html($($(a).closest(".product_filter_item"), b.responseText).html());
            var c = $(".change-view.change-view--active").data("view");
            $("#product_list").removeClass("list").removeClass("grid").addClass(c);
            var d = new Array;
          
            new Array;
            process_all_list_tag(d, $("div.root-filter").data("url"), 1), updateInitAjax(), reloadFilter(), initApollo();
          $("body,html").animate({
                scrollTop: 0
            }, 200), setTimeout(function() {
                hideLoading()
            }, 500)
   /*  var wishlist = localStorage.getItem('user_wishlist') || [];
          if (wishlist.length > 0) {
            wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
          }
          $('.wishlist-btn').each(function () {
              var productHandle = $(this).attr('data-product-handle');
              if (wishlist.indexOf(productHandle) > -1) {
                $(this).addClass('is-active');
                $(this).find('.txt_w').text('Remove Wishlist');
                $(this).attr("title", "Remove Wishlist");
                //countitem();
              }
            });
                $(document).on('click', '.wishlist-btn', function(){
              event.preventDefault;
        	  var productHandle = $(this).attr('data-product-handle');
              var isRemove = $(this).hasClass('is-active');
              var x = wishlist.length; 
             if(isRemove){
                $('<div id="alert-success" class="alert alert-danger" >Remove Wishlist</div>').insertBefore('#page').delay(1500).fadeOut(function() {$(this).remove(); });
              }
              else{
                $('<div id="alert-success" class="alert alert-success" >Add to Wishlist</div>').insertBefore('#page').delay(1500).fadeOut(function() {$(this).remove(); });
              }
              $(this).toggleClass('is-active');
              if (isRemove) {
                var removeIndex = wishlist.indexOf(productHandle);
                  wishlist.splice(removeIndex, 1);
                  localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
                  $(self).find('.txt_w').text('Add to Wishlist');
                  $(self).attr("title", "Add to Wishlist");
                   var x = wishlist.length; 
                  $('#totle-product-wishlist').text(x);
                } */
                /* Add */ 
          /*
                else {
                  wishlist.push(productHandle);
                  localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
                  $(self).find('.txt_w').text('Remove Wishlist');
                  $(self).attr("title", "Remove Wishlist");
                   var x = wishlist.length; 
                  $('#totle-product-wishlist').text(x);

                }
               })  */
           $('.wishlist-btn').bind('click',function(selector) {
                selector.preventDefault();
                updateWishlist(this);
                animateWishlist(this);
               
                  });
                getfirstvalue();
                activateItemsInWishlist();
        },
        error: function(a, b) {
            hideLoading()
        }
    }), filterMapPaging(), create_filter_price_bar(), $("div#pagination ul.pagination li a").each(function() {
        if (window.location.href.indexOf("?constraint=") >= 0) {
            var a = $(this).attr("href").split("?"),
                b = window.location.href,
                c = get_pagecount();
            for (i = 0; i < c; i++) b = b.replace("&page=" + i, "");
            var d = b + "&" + a[1];
            $(this).attr("href", d)
        }
    }), !1
});
  var arr_current_tag=process_tag_current();arr_current_tag.length&&$("h4.clear-all-filter").addClass("clear-all-filter-active");  	

  	var arr_all_list_tag = new Array();
  	var tag_current = new Array();
   	if($("div.root-filter").data("url")) process_all_list_tag(arr_all_list_tag,$("div.root-filter").data("url"),1);    
    $("div.catalog_filters h4.title_block").click(function(){$("div.catalog_filters").removeClass("findter-active"),$(this).parent().addClass("findter-active")});
    $("div#pagination ul.pagination li a").each(function(){if(window.location.href.indexOf("?constraint=")>=0){var a=$(this).attr("href").split("?"),b=window.location.href,c=get_pagecount();for(i=0;i<c;i++)b=b.replace("&page="+i,"");var d=b+"&"+a[1];$(this).attr("href",d)}});
    if($(".top-filter").length > 0){$('.top-filter').hide();}
    $(".config-filter").click(function(){if($(this).hasClass("open")){$('.top-filter').fadeOut("medium");}else{$('.top-filter').fadeIn("medium");}$(this).toggleClass("open");})
});

function updatecartpage(a){$("tr.cart__row").each(function(a){var b=Shopify.formatMoney($(this).find("input.js-qty__num").val()*$(this).data("price"),theme.moneyFormat);$(this).find("div.total-price-row").html(b)});var b=Shopify.formatMoney(a.total_price,theme.moneyFormat);$("span.cart__subtotal").html(b)}
function updateFreeShip(cart){
  var free_ship = Number(1) * 100;
  if(cart.total_price < free_ship){
   	$("div.free-ship-percen").css('width',((free_ship - cart.total_price)/free_ship) * 100 + '%');
    $("div.free-ship-lable").html($("div.free-ship-lable").html().replace("%1%",Shopify.formatMoney(free_ship - cart.total_price, theme.moneyFormat)));
  }else{
    $("div.free-ship-lable").html($("div.free-ship-lable").html().replace("%1%",0));
  }
     //console.log(Shopify.formatMoney(free_ship - cart.total_price, theme.moneyFormat));
    
}
       
$(function(){$(page).click(function(){$(document).find(".js-drawer-open").length>0&&$(".minicart_close").trigger("click")}),$(document).on("click",".mini-cart-delete",function(a){a.preventDefault();var b=$(this).data("id");$.ajax({type:"POST",url:"/cart/change.js",data:{quantity:0,id:b},success:function(a){}}),fetchMiniCart()})});
